export var getCssVarObject = (obj, type) => {
  var result = {};
  for (var key in obj) {
    result[key] = "var(--we_" + key.toLocaleLowerCase() + "_" + type + ", " + obj[key] + ")";
  }
  return result;
};
export var getCssVarDefine = (obj, type) => {
  var result = '';
  for (var key in obj) {
    result += "  --we_" + key.toLocaleLowerCase() + "_" + type + ": " + obj[key] + ";\n";
  }
  return result;
};